import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getToken, getImpersonationHeader } from "../lib/auth";

export const getAuthHeader = (token) =>
  token && { Authorization: `Bearer ${token}` };

const cache = new InMemoryCache();

export const PGA_BACKEND_CLIENT_NAME = "pga-backend";

const httpLink = createHttpLink({
  uri: (operation) => {
    const { clientName } = operation.getContext();
    if (clientName === PGA_BACKEND_CLIENT_NAME) {
      return `${process.env.REACT_APP_COACH_TOOLS_API}`;
    }
    return `${process.env.REACT_APP_GRAPHQL_ENDPOINT}`;
  },
});

const authLink = setContext(async (_, { headers }) => {
  const token = await getToken();
  return {
    headers: {
      ...headers,
      ...getAuthHeader(token),
      ...getImpersonationHeader(),
      "X-Client-Name": "events-pga-org",
    },
  };
});

const apolloClient = new ApolloClient({
  cache,
  link: authLink.concat(httpLink),
});

export default apolloClient;
